import React from 'react'
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  width: 100%;
  height: 54px;
  padding: 18px 20px 16px 20px;
  font-size: 14px;
  display: flex;
`

const TimeButton = styled.div`
  margin: 0 15px;
  cursor: pointer;
  color: ${props => props.highlight? '#F75C2F': '#4a4a4a'};
  &:first-child {
    margin-left: 30px;
  }
`

class ListHeader extends React.PureComponent {

  static propTypes = {
    changeDate: PropTypes.func.isRequired,
    filterDateType: PropTypes.any.isRequired,
    filterDate: PropTypes.string.isRequired,
  };

  changeDateToAll = () => {
    this.props.changeDate();
  }

  changeDateToThreeDay = () => {

    const { filterDateType } = this.props;
    this.props.changeDate(filterDateType.THREE_DAY);

  }

  changeDateToWeek = () => {

    const { filterDateType } = this.props;
    this.props.changeDate(filterDateType.WEEK);

  }

  changeDateToMonth = () => {

    const { filterDateType } = this.props;
    this.props.changeDate(filterDateType.MONTH);

  }

  changeDateToYear = () => {

    const { filterDateType } = this.props;
    this.props.changeDate(filterDateType.YEAR);

  }

  render() {

    const { filterDate, filterDateType } = this.props;

    return (
      <Container>
        發佈時間：
        <TimeButton
          highlight={filterDate === filterDateType.ALL}
          onClick={this.changeDateToAll}
        >
          全部
        </TimeButton>
        <TimeButton
          highlight={filterDate === filterDateType.THREE_DAY}
          onClick={this.changeDateToThreeDay}
        >
            三天內
        </TimeButton>
        <TimeButton
          highlight={filterDate === filterDateType.WEEK}
          onClick={this.changeDateToWeek}
        >
            一週內
        </TimeButton>
        <TimeButton
          highlight={filterDate === filterDateType.MONTH}
          onClick={this.changeDateToMonth}
        >
            一個月內
        </TimeButton>
        <TimeButton
          highlight={filterDate === filterDateType.YEAR}
          onClick={this.changeDateToYear}
        >
            一年內
        </TimeButton>
      </Container>
    )
  }
}

export default ListHeader;
